import React from "react";
import "./StudentsLanding.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function StudentsLanding() {
  return (
    <div className="landing">

      {/* SEO */}
      <Helmet>
        <title>Best Courses After 10th & 12th in Pakistan | SamSoftix</title>

        <meta
          name="description"
          content="Stop wasting time after exams. Join SamSoftix and learn Web Development, UI/UX, Graphic Design, Office Management, Freelancing & AI skills with online and physical classes."
        />

        <meta
          name="keywords"
          content="courses after 10th, courses after 12th, online classes Pakistan, freelancing, web development, UI UX, graphic design, SamSoftix institute"
        />

        <meta property="og:title" content="SamSoftix Skill Courses After Exams" />
        <meta property="og:description" content="Start your career early with high-income skills." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.samsoftix.com" />

        <link rel="canonical" href="https://www.samsoftix.com" />
      </Helmet>

      {/* HERO */}
      <header className="hero">

        <div className="hero-content">
          <h1>
            Your Exams Are Over — <br />
            <span>Now Build Your Future</span>
          </h1>

          <p>
            Join SamSoftix and learn job-ready skills with <b>online & physical classes</b>.
            Start earning before others even choose their career.
          </p>

          <Link to="/admission" className="primary-btn">
            Enroll Now
          </Link>

          <p className="sub-text">🎯 Online classes available all over Pakistan</p>
        </div>

      </header>

      {/* BENEFITS */}
      <section className="section">
        <h2>Why Students Choose Us</h2>

        <div className="grid">

          <div className="card">
            <h3>💻 Practical Skills</h3>
            <p>Real-world projects, not just theory.</p>
          </div>

          <div className="card">
            <h3>🚀 Career Growth</h3>
            <p>Start freelancing or get job-ready skills.</p>
          </div>

          <div className="card">
            <h3>💰 Earn Online</h3>
            <p>Learn Fiverr, Upwork & digital earning methods.</p>
          </div>

        </div>
      </section>

      {/* LEARNING MODE */}
      <section className="section alt">
        <h2>Choose Learning Mode</h2>

        <div className="grid">

          <div className="card light">
            <h3>🏫 Physical Classes</h3>
            <p>Study in a professional institute environment.</p>
          </div>

          <div className="card light">
            <h3>🌐 Online Classes</h3>
            <p>Live classes + recordings + full support.</p>
          </div>

        </div>
      </section>

      {/* COURSES */}
      <section className="courses">

        <h2>High Income Courses</h2>

        <div className="course-grid">

          <div className="course">
            <h3>💻 Development</h3>
            <ul>
              <li>Web Development</li>
              <li>React Frontend</li>
              <li>JavaScript Basics</li>
            </ul>
          </div>

          <div className="course">
            <h3>🎨 Design</h3>
            <ul>
              <li>Graphic Designing</li>
              <li>UI/UX Design</li>
              <li>Photoshop & Canva</li>
            </ul>
          </div>

          <div className="course">
            <h3>📊 Office Skills</h3>
            <ul>
              <li>MS Office</li>
              <li>Office Management</li>
              <li>Data Entry</li>
            </ul>
          </div>

          <div className="course">
            <h3>🌐 Online Earning</h3>
            <ul>
              <li>Freelancing</li>
              <li>Fiverr / Upwork</li>
              <li>Digital Marketing</li>
            </ul>
          </div>

          <div className="course">
            <h3>🤖 Modern Skills</h3>
            <ul>
              <li>AI & ChatGPT</li>
              <li>Content Creation</li>
              <li>Social Media Growth</li>
            </ul>
          </div>

        </div>

      </section>

      {/* CTA */}
      <section className="cta-section">

        <h2>Limited Seats Available</h2>
        <p>Start your journey today with SamSoftix professional training.</p>

        <Link to="/admission" className="primary-btn dark">
          Apply Now
        </Link>

      </section>

      {/* OFFER */}
      <section className="offer">
        <h2>🎁 Special Offer</h2>
        <p>Enroll now and get a chance to win a FREE Laptop.</p>
      </section>

      {/* FOOTER */}
      <footer>
        <p>© 2026 SamSoftix Software House</p>
        <p>www.samsoftix.com</p>
      </footer>

    </div>
  );
}